import { Injectable } from '@angular/core';

import {
  TriggerNotificationEventParams,
  TriggerNotificationEventResponse,
} from '..';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  constructor(private readonly apiService: ApiService) {}

  triggerNotificationEvent(
    triggerNotificationEventParams: TriggerNotificationEventParams
  ): Observable<TriggerNotificationEventResponse> {
    return this.apiService.post(
      `/v1/notification/event`,
      triggerNotificationEventParams
    );
  }
}
